export default __webpack_public_path__ + "static/media/cook8.b5bbb5c7.png";